import React, { useState } from "react";
import Layout from "./Layout";
const SaviruchiImage = () => {
  return (
    <Layout
    />
  );
};

export default SaviruchiImage;
